import React, { useState, useEffect } from 'react';
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";

var CashIn = function CashIn() {
  return /*#__PURE__*/_jsx(_Fragment, {});
};

export default CashIn;